import { render, staticRenderFns } from "./NewContactButton.vue?vue&type=template&id=63210174&"
import script from "./NewContactButton.vue?vue&type=script&lang=ts&"
export * from "./NewContactButton.vue?vue&type=script&lang=ts&"
import style0 from "./NewContactButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports